import { useEffect, useState } from "react";

export const useDeviceTier = () => {
  const [state, setState] = useState({ isMobile: false, reducedMotion: false, tier: "high" });

  useEffect(() => {
    const compute = () => {
      const isMobile = window.innerWidth < 768 || /Mobi|Android/i.test(navigator.userAgent);
      const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      const cores = navigator.hardwareConcurrency || 4;
      const tier = reducedMotion ? "low" : isMobile || cores <= 4 ? "medium" : "high";
      setState({ isMobile, reducedMotion, tier });
    };
    compute();
    window.addEventListener("resize", compute);
    return () => window.removeEventListener("resize", compute);
  }, []);

  return state;
};
